<template>
    <div class="section-header mb-6">
        <div class="d-flex align-center flex-wrap" style="gap:12px">
            <h2 class="section-title mr-auto">
                <v-icon
                    v-if="icon"
                    color="primary"
                    class="mr-2"
                    size="22"
                >
                    {{ icon }}
                </v-icon>
                <slot name="title">{{ title }}</slot>
            </h2>

            <div
                v-if="$slots.actions"
                class="d-flex align-center"
                style="gap:8px;flex-shrink:0"
            >
                <slot name="actions" />
            </div>
        </div>

        <p
            v-if="subtitle || $slots.subtitle"
            class="body-sm ma-0 mt-1"
        >
            <slot name="subtitle">{{ subtitle }}</slot>
        </p>
    </div>
</template>

<script>
export default {
    name: 'SectionHeader',
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: null,
        },
    },
}
</script>
